<template>
    <div class="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      <!-- 简约头部 -->
      <header class="py-6">
        <div class="container-custom">
          <div class="flex items-center justify-between">
            <router-link to="/" class="flex items-center space-x-2 group">
              <div class="w-10 h-10 bg-gradient-primary rounded-xl flex items-center justify-center transform group-hover:rotate-12 transition-transform duration-300">
                <span class="text-white font-bold">V</span>
              </div>
              <span class="text-xl font-bold text-gray-900">VueSite</span>
            </router-link>
            
            <nav class="hidden md:flex items-center space-x-8">
              <router-link 
                to="/" 
                class="text-gray-600 hover:text-primary-600 transition-colors"
                exact-active-class="text-primary-600 font-medium"
              >
                返回首页
              </router-link>
              <button @click="$router.back()" class="btn-outline">
                返回上一页
              </button>
            </nav>
            
            <button @click="toggleMobileMenu" class="md:hidden p-2">
              <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path v-if="!mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                <path v-if="mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <!-- 移动端菜单 -->
          <div v-if="mobileMenuOpen" class="md:hidden mt-4 bg-white rounded-lg shadow-lg p-4">
            <div class="space-y-3">
              <router-link 
                to="/" 
                class="block py-2 px-4 rounded hover:bg-gray-50"
                @click="mobileMenuOpen = false"
              >
                返回首页
              </router-link>
              <button 
                @click="$router.back(); mobileMenuOpen = false"
                class="w-full btn-outline"
              >
                返回上一页
              </button>
            </div>
          </div>
        </div>
      </header>
  
      <!-- 主要内容 -->
      <main class="flex-grow py-12">
        <slot />
      </main>
  
      <!-- 简约页脚 -->
      <footer class="py-8 border-t border-gray-200">
        <div class="container-custom">
          <div class="text-center">
            <p class="text-gray-600 mb-4">
              © 2024 VueWebsite. 保留所有权利。
            </p>
            <div class="flex items-center justify-center space-x-6">
              <a href="/privacy" class="text-sm text-gray-500 hover:text-gray-700">隐私政策</a>
              <a href="/terms" class="text-sm text-gray-500 hover:text-gray-700">服务条款</a>
              <a href="/contact" class="text-sm text-gray-500 hover:text-gray-700">联系我们</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MinimalLayout',
    data() {
      return {
        mobileMenuOpen: false
      }
    },
    methods: {
      toggleMobileMenu() {
        this.mobileMenuOpen = !this.mobileMenuOpen
      }
    }
  }
  </script>